<template>
    <div>
        <div class="parallax">
        </div>
        <div class="container">
            <div class="row pt-5 pb-3" v-if="offer!=null">
                <div class="col-md-5">
                    <img :src="getOfferImage(offer.image)" class="img-fluid" alt="">
                </div>
                <div class="col-md-7">
                    <h4 class="featurette-heading">😍 {{offer.title}} <span class="text-muted"></span></h4>
                    <p style="font-size:15px;" class="lead"> {{offer.description}} </p>
                    <div class="icon mb-3"><span><i class="fas fa-map"></i></span> {{offer.place}} </div> 
                    <button class="btn btn-outline-primary">Réserver</button>
                </div>
            </div>
            <hr>
            <div class="row p-3">
                <div class="col-md-1">
                    POINTS FORTS
                </div>
                <div class="col-md-11">
                    <div class="row">
                        <div class="col">
                            <div class="text-center">
                                <img class="mb-3" src="https://cdn.vacancesbleues.resalys.com/sites/default/files/VueMer.png" alt="">
                                <p>Vue Mer</p>
                            </div>
                        </div>
                        <div class="col">
                            <div class="text-center">
                                <img class="mb-3" src="https://cdn.vacancesbleues.resalys.com/sites/default/files/LieuDeCaractere_0.png" alt="">
                                <p class="">Ancien Palace</p>
                            </div>
                        </div>
                        <div class="col">
                            <div class="text-center">
                                <img class="mb-3" src="https://cdn.vacancesbleues.resalys.com/sites/default/files/Animations_0.png" alt="">
                                <p class="">Animations</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <h3 class="mb-4">PROMOTIONS</h3>
            <div class="row mb-5 pl-3">
                <div class="col-md-1 bg-warning text-dark"> <h2>-10%</h2> </div>
                <div class="col-md-9 bg-warning text-dark"> -10% cumulable avec les réductions "Réservez-tôt" pour tout séjour à partir de 15 jours/14 nuits en demi pension ou en pension complète (hors du 05/06 au 18/09/2021) </div>
            </div>
        </div>

        <Footer></Footer>
    </div>
</template>

<style lang="scss">
    
</style>

<script>

import Footer from '@/components/Footer.vue'
import axios from "axios";

export default {
    components: {
        Footer
    },
    data() {
        return {
            offer: null,
            detail_offre: [
                {
                    lien: "https://cdn.vacancesbleues.resalys.com/sites/default/files/VueMer.png",
                    text: "",
                },
                {
                    lien: "https://cdn.vacancesbleues.resalys.com/sites/default/files/LieuDeCaractere_0.png",
                    text: "",
                },
                {
                    lien: "https://cdn.vacancesbleues.resalys.com/sites/default/files/Animations_0.png",
                    text: "",
                },
            ],
        }
    },
    methods: {
        getOfferImage(image) {
            return require("../assets/images/offres/"+image);
        },
        getOfferInfo() {
            // var url = 'http://localhost:8000/api/search/'+this.description+'/'+this.price+'/'+this.place;
            var url = 'http://localhost:8000/api/offers/'+this.$route.params.id;
            axios
                .get(url)
                .then(response => {
                    this.offer = response.data.data;
                })
                .catch(error => console.log(error));
        }
    },
    mounted() {
        this.getOfferInfo();
    },
    
}
</script>